import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createTestmethodSlice = createAsyncThunk(
  "testMethod/createTestmethod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/testMethod/createTestmethod", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const getAllTestmethod = createAsyncThunk(
  "testMethod/getAllTestmethod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/testMethod/getAllTestmethod", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);
export const getTestMethodByIdSlice = createAsyncThunk(
  "testMethod/getTestMethodById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/testMethod/getTestMethodById", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const updateTestMethodTypeSlice = createAsyncThunk(
  "testMethod/updateTestMethod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/testMethod/updateTestMethod", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

export const deleteTestMethodTypeSlice = createAsyncThunk(
  "testMethod/deleteTestMethod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/testMethod/deleteTestMethod", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  },
);

const initialState = {
  loading: false,
  testMethod: [],
  testMethodTypeInfo: [],
  createTestmethodTypeSuccessMessage: null,
  createTestmethodTypeErrorMessage: null,
  updateTestmethodTypeSuccessMessage: null,
  updateTestmethodTypeErrorMessage: null,
  deleteTestmethodTypeSuccessMessage: null,
  deleteTestmethodTypeErrorMessage: null,
  searchTestmethodTypeErrorMessage: null,
  totalRecords: 0,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
};
const testMethodSlice = createSlice({
  name: "testmethod",
  initialState,
  reducers: {
    resetCreatetestMethodMessage: (state) => {
      state.createTestmethodTypeSuccessMessage = null;
      state.createTestmethodTypeErrorMessage = null;
    },
    resetUpdatetestMethodMessage: (state) => {
      state.updateTestmethodTypeSuccessMessage = null;
      state.updateTestmethodTypeErrorMessage = null;
    },
    resetDeletetestMethodTypeMessage: (state) => {
      state.deleteTestmethodTypeSuccessMessage = null;
      state.deleteTestmethodTypeErrorMessage = null;
    },
    resetSearchTestmethodMessage: (state) => {
      state.searchTestmethodTypeErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTestmethodSlice.pending, (state) => {
        state.loading = true;
        state.createTestmethodTypeSuccessMessage = null;
        state.createTestmethodTypeErrorMessage = null;
      })
      .addCase(createTestmethodSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.createTestmethodTypeErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.createTestmethodTypeSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(createTestmethodSlice.rejected, (state, action) => {
        state.loading = false;
        state.createTestmethodTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(getAllTestmethod.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTestmethod.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.searchTestmethodTypeErrorMessage =
            action?.payload?.result?.message;
          state.testMethod = [];
          return;
        }
        if (action.payload.result.currentPage === 1) {
          state.testMethod = action.payload.result.list;
        } else {
          const newList = action.payload.result.list.filter(
            (item) =>
              !state.testMethod.some((existing) => existing._id === item._id),
          );
          state.testMethod = [...state.testMethod, ...newList];
        }
        state.currentPage = action.payload.result.currentPage;
        state.totalPages = action.payload.result.totalPages;
        state.hasMore = action.payload.result.hasMore;
        state.searchTestmethodTypeErrorMessage = null;
      })
      .addCase(getAllTestmethod.rejected, (state, action) => {
        state.loading = false;
        state.searchTestmethodTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(getTestMethodByIdSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTestMethodByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.testMethodTypeInfo = action?.payload?.result?.list;
      })
      .addCase(getTestMethodByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.searchTestmethodTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(updateTestMethodTypeSlice.pending, (state) => {
        state.loading = true;
        state.updateTestmethodTypeSuccessMessage = null;
        state.updateTestmethodTypeErrorMessage = null;
      })
      .addCase(updateTestMethodTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateTestmethodTypeErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.updateTestmethodTypeSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(updateTestMethodTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.updateTestmethodTypeErrorMessage =
          action?.payload?.result?.message;
      })
      .addCase(deleteTestMethodTypeSlice.pending, (state) => {
        state.loading = true;
        state.deleteTestmethodTypeSuccessMessage = null;
        state.deleteTestmethodTypeErrorMessage = null;
      })
      .addCase(deleteTestMethodTypeSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.deleteTestmethodTypeErrorMessage =
            action?.payload?.result?.message;
        } else {
          state.deleteTestmethodTypeSuccessMessage =
            action?.payload?.result?.message;
        }
      })
      .addCase(deleteTestMethodTypeSlice.rejected, (state, action) => {
        state.loading = false;
        state.deleteTestmethodTypeErrorMessage =
          action?.payload?.result?.message;
      });
  },
});
export const {
  resetCreatetestMethodMessage,
  resetUpdatetestMethodMessage,
  resetDeletetestMethodTypeMessage,
  resetSearchTestmethodMessage,
} = testMethodSlice.actions;

export default testMethodSlice.reducer;
